<template>
    <layout-admin>
        <div slot="sidebar" class="mt-3 pb-3">

            <b-list-group>
                <b-list-group-item :to="{name:'pageSetting',params:{key:'website'}}">تنظیمات سایت</b-list-group-item>
                <b-list-group-item :to="{name:'pageSetting',params:{key:'contact'}}">تنظیمات تماس</b-list-group-item>
            </b-list-group>


        </div>
        <div slot="content" class="">

            <b-navbar class="px-0 pt-3" type="light" variant="light">
                <b-navbar-brand href="#"></b-navbar-brand>

                <b-button  variant="outline-primary" v-if="$route.params.key" :to="{name:'pageSetting'}" >بازگشت</b-button>

            </b-navbar>

            <b-card no-body class="form-card mt-2" v-if="$route.params.key == 'website'">

                <b-tabs card class="">
                    <b-tab title="درباره ما " active>
                        <form-about edit="about"/>

                    </b-tab>
                    <b-tab title="قوانین و مقررات" >
                        <form-term edit="terms"/>

                    </b-tab>
                    <!-- <b-tab title="آزمایشگاه تجهیزات" active>
                        <form-laboratory edit="laboratory"/>

                    </b-tab> -->
                </b-tabs>
            </b-card>

            <b-card no-body class="form-card mt-2" v-if="$route.params.key == 'contact'">
                <b-tabs card class="">
                    <b-tab title="تنظیمات تماس" active>

                        <form-contact edit="contact"/>
                    </b-tab>
                </b-tabs>
            </b-card>

        </div>
    </layout-admin>
</template>

<script>
import MainLayout from "../layouts/MainLayout";
import LayoutAdmin from "../layouts/LayoutAdmin";
import FormAbout from "../forms/setting/FormAbout";
import FormLaboratory from "../forms/setting/FormLaboratory";
import FormTerm from "../forms/setting/FormTerm";
import FormContact from "../forms/setting/FormContact";

export default {
  components: {
    LayoutAdmin,
    MainLayout,
    FormAbout,
    FormLaboratory,
    FormTerm,
    FormContact
  },
  name: "PageSetting",
  metaInfo: {
    title: "تنظیمات"
  },
  computed: {},
  data() {
    return {};
  },
  methods: {},
  created() {}
};
</script>

<style>
.sub-list-group-item {
  margin-bottom: -1px;
}

.sub-list-group-item .list-group-item:not(.active) {
  border-right: solid 5px #005cbf;
  background-color: #eee;
}

.sub-list-group-item .list-group-item:first-child {
  border-top-right-radius: 0rem;
  border-top-left-radius: 0rem;
}

.sub-list-group-item .list-group-item:first-child {
  border-top-right-radius: 0rem;
  border-top-left-radius: 0rem;
}

.sub-list-group-item .list-group-item:last-child {
  border-bottom-left-radius: 0rem;
  border-bottom-right-radius: 0rem;
}
</style>


// WEBPACK FOOTER //
// src/components/pages/PageSetting.vue